import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { getGetFrontRichiesteIdPreventiviIdDownloadQueryOptions } from '@framework/api-client/api/inquiries-compile/preventivi-richiesta/preventivi-richiesta.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { useHasDocumentsInlineViewer } from '@framework/common-web/ui/documents/useHasDocumentsInlineViewer.tsx';
import { useAuthDownload } from '@framework/common-web/utils/download/useAuthDownload.ts';
import { Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

export interface IQuoteDownloadButtonProps {
  submissionId: string;
  quoteId: string;
}

/**
 * Pulsante azione "Scarica" per il download di un preventivo.
 */
export function QuoteDownloadButton(props: IQuoteDownloadButtonProps) {
  const { submissionId, quoteId } = props;

  const { t } = useTranslation();
  const hasInlineViewer = useHasDocumentsInlineViewer();
  const theme = useTheme();

  const { download, isFetching } = useAuthDownload(
    getGetFrontRichiesteIdPreventiviIdDownloadQueryOptions,
    [submissionId, quoteId],
    {
      onError: e => {
        // biome-ignore format: <tbd>
        console.error(`[QuoteDownloadButton] Impossibile scaricare il preventivo`, { e });
        // biome-ignore format: <tbd>
        message.error(getNetworkErrorMessage(e, t('quote-table.errore-in-download-file', 'Si è verificato un problema durante il download del file')));
      },
      showInlineViewer: hasInlineViewer,
    },
  );

  return (
    <Button
      icon={
        !hasInlineViewer ? (
          <DownloadOutlined
            aria-label={t(
              'quote-table.azioni.button.aria-label.scarica-preventivo',
              'Scarica Preventivo',
            )}
          />
        ) : (
          <EyeOutlined aria-label={`${theme.viewPdfLabel} Preventivo`} />
        )
      }
      onClick={() => {
        download();
      }}
      loading={isFetching}
    />
  );
}
